import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ step, stepList, currentStepName }) => {
  const stepPercent = ((step + 1) / stepList.length) * 100;
  const isCompleted =
    currentStepName === 'Success' || currentStepName === 'Q38';

  return (
    <div className="w-full">
      <div className="w-full">
        <div className="row d-flex ph-5">
          <div className="col align-center w-100" style={{ flexGrow: 1 }}>
            <div className="progress-bar-container">
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${stepPercent}%` }}
                ></div>
              </div>

              {!isCompleted ? (
                <p className="">
                  {step + 1}/{stepList.length}
                </p>
              ) : (
                <div className="icon-check flex ml-2">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.705 2.54008C14.92 1.03008 12.58 0.0800781 10 0.0800781C7.42 0.0800781 5.08 1.03008 3.295 2.54008C1.27 4.36508 0 7.02508 0 9.96008C0 13.6101 1.905 16.7451 4.8 18.5301C6.31 19.4051 8.095 19.9201 10 19.9201C11.905 19.9201 13.69 19.4051 15.2 18.5301C18.095 16.7851 20 13.6101 20 10.0001C20 7.02508 18.73 4.36508 16.705 2.54008ZM8.375 15.2001L3.495 10.3601L4.605 9.25008L8.375 12.9401L15.515 5.95008L16.625 7.06008L8.375 15.2001Z"
                      fill="#006FBA"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  step: PropTypes.number.isRequired,
  stepList: PropTypes.array.isRequired,
  currentStepName: PropTypes.string.isRequired,
};

export default ProgressBar;
